import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Menu as BaseMenu } from 'antd';

const BusinessList = ({ business, businesses }) => {
  if (businesses.length < 2) {
    return <></>;
  }

  const setBusiness = (currentBusiness) => {
    const params = new URLSearchParams(window.location.search);
    params.set('bizslug', currentBusiness.slug);
    window.location = `/?${params.toString()}`;
  };

  return (
    <BaseMenu.SubMenu
      title={(
        <span className="submenu-title-wrapper">
          <Icon type="shop" />
          {business.name}
        </span>
      )}
    >
      {businesses
        .filter((biz) => biz.id !== business.id)
        .map((biz) => <BaseMenu.Item key={`business:${biz.id}`} onClick={() => setBusiness(biz)}>{biz.name}</BaseMenu.Item>)}
    </BaseMenu.SubMenu>
  );
};

BusinessList.propTypes = {
  business: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  businesses: PropTypes.array,
};

export default BusinessList;
